export default __webpack_public_path__ + "static/media/chukwunda.e33e379e.png";